import { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

import useTableContext from 'components/admin-portal/BaseTabsRouting/Headers/HeaderGrid/useTableContext';
import BackToListButton from 'components/shared/CRUD/components/InnerPage/components/BackToListButton';
import InnerViewNavigator from 'components/shared/CRUD/components/InnerPage/components/InnerViewNavigator';
import {
  StyledToolbarContentBox,
  StyledToolbarMainBox
} from 'components/shared/CRUD/components/InnerPage/components/ToolbarContent.styles';

import type { ProtocolResponse } from 'generated/index';
import type { ProtocolDetailToolbarProps } from './ProtocolDetailToolbar.types';

/**
 * The inner page toolbar of Planeenheden (`ToolbarContent`), portalled into the tab header: jump to
 * another protocol and back to the list. Editing is the pencil on the protocol's card.
 */
const ProtocolDetailToolbar = ({
  protocol,
  protocols,
  onSelect,
  onBack
}: ProtocolDetailToolbarProps) => {
  'use memo';
  const { contentNodeForButtons } = useTableContext();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (contentNodeForButtons?.current) setIsLoaded(true);
  }, [contentNodeForButtons]);

  if (!isLoaded || !contentNodeForButtons.current) {
    return null;
  }

  return createPortal(
    <StyledToolbarContentBox>
      <StyledToolbarMainBox>
        <InnerViewNavigator
          currentView={protocol}
          views={protocols}
          setCurrentView={(selected?: ProtocolResponse) =>
            selected && onSelect(selected.id)
          }
          navigatorValueGetter="id"
          navigatorLabelGetter={['name']}
        />
        <BackToListButton closeInnerView={onBack} />
      </StyledToolbarMainBox>
    </StyledToolbarContentBox>,
    contentNodeForButtons.current
  );
};

export default ProtocolDetailToolbar;
